import { PayloadAction } from "@reduxjs/toolkit";
import { put, call, all } from "redux-saga/effects";

import { IKeyData } from "infrastructure";
import { notification } from "infrastructure/notification";
import { takeLatest } from "infrastructure/store/sagaEffects";
import { securityMessages } from "ui/screens/security/security.localization";
import { filterPickerData } from "ui/screens/security/shared/picker";

import { roleActions } from "./SecurityRole.actions";
import { getSecurityRolesByTenant, getSecurityRolesByEnterprise } from "./SecurityRole.api";
import { ISecurityRolesResponse } from "./SecurityRole.api.types";
import { ISecurityRole, ISecurityRoleSearchCriterion } from "./SecurityRole.state";

function* loadSecurityRolesExecute({ payload }: PayloadAction<IKeyData<ISecurityRoleSearchCriterion>>) {
  try {
    let rolesResponse: ISecurityRolesResponse[] = [];

    if (payload.data.tenantId) {
      rolesResponse = yield call(getSecurityRolesByTenant, {
        tenantId: payload.data.tenantId,
        filter: payload.data.query.query
      });
    } else if (payload.data.enterpriseId) {
      rolesResponse = yield call(getSecurityRolesByEnterprise, {
        enterpriseId: payload.data.enterpriseId,
        filter: payload.data.query.query
      });
    }

    const roles: ISecurityRole[] = filterPickerData(
      rolesResponse.map<ISecurityRole>(e => {
        return {
          securityRoleId: e.securityRoleId,
          name: e.name
        };
      }),
      { ...payload.data, defaultValueProvider: payload.data.defaultValueProvider ? payload.data.defaultValueProvider : e => e.name }
    );

    yield put(
      roleActions.loadSecurityRolesCompleted({
        id: payload.id,
        data: roles
      })
    );
  } catch (e) {
    yield put(
      roleActions.loadSecurityRolesFailed({
        id: payload.id,
        data: notification.error(e).useMessageId(securityMessages.error("loadRolesFailed"))
      })
    );
  }
}

export function* rolesSaga() {
  yield all([yield takeLatest(roleActions.loadSecurityRoles.toString(), loadSecurityRolesExecute)]);
}
